import React from "react";
import Layout from "components/Layout";
import { fetchAppCheckout, fetchAppBuilder } from "actions/app";
import { createShortLink } from "actions/shortLink";
import { fetchMockUserDetails, fetchUserDetails } from "actions/auth";
import { fetchMerchantAccountTaxRates } from "actions/taxRate";
import { fetchMerchantAccountShippingRates } from "actions/shippingRate";
import {
  fetchMerchantAccountProductsPrices,
  fetchMerchantAccountCouponsPromotionCodes
} from "actions/merchantAccount";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { TEST_PARAMS } from "utils/constants/request";
import ShortLinkBuilder from "components/ShortLinkBuilder";
import { ApplicationContextProvider } from "utils/context";
import BuilderLinkLoader from "components/BuilderLinkLoader";
import { ENV } from "utils/constants/env";
import UnauthEducationModal from "components/UnauthEducationModal";
import { LINK_BUILDER_ONBOARDING } from "constants/education";
import { ensureUnauthInit } from "utils/hooks/unauth";
import RefreshOrReturnNotice from "components/RefreshOrReturnNotice";

const UnauthedLinksFeatureBuilderContainer = ({ actions }) => {
  const { loading, hasData, application, merchantAccount } = ensureUnauthInit({
    fetchMerchantAccountProductsPrices:
      actions.fetchMerchantAccountProductsPrices,
    fetchMerchantAccountCouponsPromotionCodes:
      actions.fetchMerchantAccountCouponsPromotionCodes,
    fetchMerchantAccountTaxRates: actions.fetchMerchantAccountTaxRates,
    fetchMerchantAccountShippingRates:
      actions.fetchMerchantAccountShippingRates,
    fetchAppCheckout: actions.fetchAppCheckout,
    fetchAppBuilder: actions.fetchAppBuilder,
    fetchUserDetails: actions.fetchUserDetails,
    fetchMockUserDetails: actions.fetchMockUserDetails
  });

  return (
    <Layout>
      {() =>
        loading ? (
          <BuilderLinkLoader />
        ) : hasData ? (
          <ApplicationContextProvider
            application={application}
            merchantAccount={merchantAccount}
            env={ENV.TEST}
          >
            <ShortLinkBuilder requestParams={TEST_PARAMS} />
            <UnauthEducationModal uid={LINK_BUILDER_ONBOARDING} />
          </ApplicationContextProvider>
        ) : (
          <RefreshOrReturnNotice />
        )
      }
    </Layout>
  );
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      createShortLink,
      fetchAppCheckout,
      fetchAppBuilder,
      fetchUserDetails,
      fetchMockUserDetails,
      fetchMerchantAccountProductsPrices,
      fetchMerchantAccountCouponsPromotionCodes,
      fetchMerchantAccountTaxRates,
      fetchMerchantAccountShippingRates
    },
    dispatch
  )
});

export default connect(
  null,
  mapDispatchToProps
)(UnauthedLinksFeatureBuilderContainer);
